import Button from 'components/Button/Button'
import styled from 'styled-components'

export const StyledLoadError = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 30vh;
  color: #495057;
  text-wrap: pretty;
  text-align: center;
  margin-top: 20px;

  h1 {
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
    margin-bottom: 0px;
  }

  h2 {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 20px;
  }
`

export const StyledWarningIcon = styled.div`
  path {
    stroke: #f18500;
  }
  circle {
    stroke: #f18500;
  }
  line {
    stroke: #f18500;
  }
`
export const StyledTryAgainButton = styled(Button)<any>`
  min-width: 100px;
  height: 26px;
`
